import { render, staticRenderFns } from "./studentInfoCertificationRecord_1.vue?vue&type=template&id=c2fb7e1e&scoped=true"
import script from "./studentInfoCertificationRecord_1.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord_1.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord_1.vue?vue&type=style&index=0&id=c2fb7e1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fb7e1e",
  null
  
)

export default component.exports